<div class="fault-download-progress">
  <div class="fault-download-progress-header">
    <mydocma-custom-mat-icon [iconName]="'_warning-filled'" style="color: #FFBA00; display: flex; align-items: center;"></mydocma-custom-mat-icon>
    <p>{{dialogData.header$ | async}}</p>
  </div>
  <div class="fault-download-progress-content">
    <p>{{dialogData.body$ | async }}</p>
  </div>
  <div class="fault-download-progress-bar-container">
    <mat-progress-bar
      *ngIf="(dialogData.processedFilesAmount$ | async) != undefined && (dialogData.totalFilesAmount$ | async) != undefined"
      class="progress-bar"
      mode="determinate"
      color="primary"
      [value]="(((dialogData.processedFilesAmount$ | async) || 0) / (dialogData.totalFilesAmount$ | async)) * 100">
    </mat-progress-bar>
    <p *ngIf="(dialogData.progressText$ | async) !== null">{{dialogData.progressText$ | async}}</p>
    <p *ngIf="(dialogData.progressText$ | async) === null">{{((dialogData.processedFilesAmount$ | async) || 0) }} / {{ dialogData.totalFilesAmount$ | async }} {{ dialogData.recordsText$ |async }} </p>  </div>
  <div class="fault-download-progress-footer">
    <button *ngIf="(dialogData.showCancel$ | async)" mat-stroked-button (click)="onCancel()" class="mydocma-btn">
      {{ translations.cancel }}
    </button>
  </div>
</div>

